import { useContext, useState } from "react";
import toast from "react-hot-toast";

import { AuthContext } from "../contexts/auth";
import getServices from "../services/getServices";

const useUsuariosClientesState = () => {
  const { signOut } = useContext(AuthContext);
  const [submit, setSubmit] = useState(false);
  const [pesquisa, setPesquisa] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const buscar = async (pagina = 1) => {
    if (submit) return;
    setSubmit(true);
    const resultado = await getServices("admin/usuarios-clientes/", { pesquisa, page: pagina });

    if (resultado.type === "success") {
      setUsuarios(resultado.data.results || resultado.data);
      setTotal(resultado.data.count ?? resultado.data.length);
      setPage(pagina - 1);
    } else if (resultado.data?.code === "token_not_valid") {
      signOut();
    } else {
      toast.error(resultado.data?.detail || "Não foi possível carregar os usuários clientes.");
    }
    setSubmit(false);
  };

  return {
    usuarios: { value: usuarios },
    pesquisa: { value: pesquisa, set: setPesquisa },
    submit: { value: submit, set: buscar },
    pagination: { total, page, setPage },
    openDialog: { value: false, set: () => {} },
    itemDelete: { value: null, set: () => {} },
    deletar: { set: () => {} },
  };
};

export default useUsuariosClientesState;
